import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import ReactDnD from '../common/ReactDnD';
import {
  setSelectedTopic,
  setSelectedTopicInfo,
  setTopicsSidebar,
  showProgress,
} from '../../redux/actions/DealershipActions';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import Service from '../../apis/service';
import Modal from '../common/Modal';
import JourneyCard, { AllJourneysList, MenuItems } from '../common/JourneyCard';
import ZeroState from '../common/ZeroState';
import FileIcon from '../../assets/FileIcon';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyle = makeStyles({
  container: {
    marginLeft: '50px',
  },
  heading: {
    width: '97%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 10px',
  },
  add: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  journeyList: {
    margin: '20px 0px',
    width: '100%',
    height: '500px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
});

export default function RightsideTopic() {
  const classes = useStyle();
  const dispatch = useDispatch();

  const selectedTopicInfo = useSelector((state) => state.topicsData.selectedTopicInfo);
  const selectedTopic = useSelector((state) => state.topicsData.selectedTopic);

  const [anchorEl, setAnchorEl] = useState(null);
  const [availableJourneys, setAvailableJourneys] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [filteredJourneys, setFilteredJourneys] = useState([]);
  const [selectedJourneys, setSelectedJourneys] = useState([]);
  const [journeys, setJourneys] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const fetchSelectedTopicInfo = async () => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.TOPIC_BY_ID.replace('ID', selectedTopic.id));
      dispatch(setSelectedTopicInfo(res));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const fetchSidebarList = async (flag = true) => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.TOM_TOPICS_BY_DATES);
      dispatch(setTopicsSidebar(res));
      if (!_isEmpty(res) && flag) {
        handleListItemClick(res[0]);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));
    if (!_isEmpty(data)) {
      dispatch(setSelectedTopic(data));
    }
    dispatch(showProgress(false));
  };

  const handleUpdateJourney = async (journeyIds) => {
    dispatch(showProgress(true));
    try {
      await Service.post(apiEndpoints.TOPIC_ADD_JOURNEY.replace('ID', selectedTopicInfo.id), {
        journeys: journeyIds,
      });
      setIsOpenModal(false);
      fetchSelectedTopicInfo();
      fetchSidebarList(false);
      notifySuccess('Jouney updated successfully');
    } catch (error) {
      setAvailableJourneys(selectedTopicInfo?.journeys || []);
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getAddJourneyList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.GET_JOURNEYS);
      setJourneys(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getAddJourneyList();
  }, []);

  const handleAddBtn = () => {
    setIsOpenModal(true);
  };

  useEffect(() => {
    setAvailableJourneys(selectedTopicInfo?.journeys || []);
    const temp = selectedTopicInfo?.journeys?.map((data) => data.id);
    setSelectedJourneys(temp || []);
  }, [selectedTopicInfo]);

  const handleSelectJourney = (id) => {
    if (selectedJourneys.includes(id)) {
      setSelectedJourneys((prevSelectedJourneys) => prevSelectedJourneys.filter((journeyId) => journeyId !== id));
    } else {
      setSelectedJourneys((prevSelectedJourneys) => [...prevSelectedJourneys, id]);
    }
  };

  const handleDeleteJourney = () => {
    const temp = availableJourneys.filter((data) => data.id !== selectedId).map((data) => data.id);
    handleUpdateJourney(temp);
    setAnchorEl(null);
  };

  return (
    <Grid className={classes.container}>
      <Grid className={classes.heading}>
        <Typography variant="h6">Topic Content</Typography>
        <Grid className={classes.add} onClick={handleAddBtn}>
          <Add />
        </Grid>
      </Grid>
      {availableJourneys?.length ? (
        <>
          <ReactDnD
            data={availableJourneys}
            setData={setAvailableJourneys}
            setModifiedOrderIds={handleUpdateJourney}
            renderItem={(journeyData) => (
              <JourneyCard journeyData={journeyData} setSelectedId={setSelectedId} setAnchorEl={setAnchorEl} />
            )}
          />

          <MenuItems anchorEl={anchorEl} setAnchorEl={setAnchorEl} onDelete={handleDeleteJourney} />
        </>
      ) : (
        <Grid className={classes.journeyList}>
          <Grid item>
            <ZeroState
              Icon={FileIcon}
              title="You don’t have any journeys added in this topic."
              text="Add at least 1 journey for the topic to be visible in the app."
              style={{ paddingBottom: '100px', marginTop: '40px' }}
              cardWidth="36vw"
              btnText="Add Journey"
              btnAction={() => setIsOpenModal(true)}
            />
          </Grid>
        </Grid>
      )}

      <Modal isOpen={isOpenModal} height="700px" width="700px">
        <AllJourneysList
          filteredJourneys={filteredJourneys}
          setFilteredJourneys={setFilteredJourneys}
          journeys={journeys}
          handleSelectJourney={handleSelectJourney}
          selectedJourneys={selectedJourneys}
          setSelectedJourneys={setSelectedJourneys}
          handleUpdateJourney={handleUpdateJourney}
          setIsOpenModal={setIsOpenModal}
        />
      </Modal>
    </Grid>
  );
}
